import {ITheme} from "@/types/theme.ts";

export const theme: ITheme = {
    colors: {
        primary: '#4D699C',
        secondary: '#E3E3E3',
        success: '#508229',
        danger: 'rgb(219, 51, 36)',
        blue: 'rgb(77, 105, 156)',
        green: 'rgb(80, 130, 41)',

        bg: '#F2F2F2',
        fontLink: '#2358A2',

        buttons: {
            hover: {
                primary: '#435b88',
                secondary: '#f5f5f5',
                green: 'rgb(80, 130, 41)',
                blue: 'rgb(77, 105, 156)'
            }
        }
    },
}